import React, { useCallback, useEffect, useRef, useMemo } from 'react';
import Modal from '@components/Modal';
import RateModalForm from './RateModalForm';
import SampleLoan from './SampleLoan';
import * as styles from './RateModal.module.scss';
import classNames from 'classnames';
import tracker from '@utils/tracker';

export default React.memo(function RateModal({
  id,
  product,
  loanDetails: loanInfo,
  isRackRate,
  setProduct
}) {
  const close = useCallback(() => setProduct(null), [setProduct]);
  const loanDetails = useMemo(() => {
    return !isRackRate ? loanInfo : (product?.loanDetails ?? loanInfo);
  }, [isRackRate, loanInfo, product]);

  const modal = useRef();
  const content = useRef();
  const scrollTimer = useRef();
  const prevProduct = useRef(null);

  const visibleProduct = product ?? prevProduct.current;

  useEffect(() => {
    clearTimeout(scrollTimer.current);

    if (product) {
      if (prevProduct.current !== product) {
        setTimeout(() => {
          tracker.track(tracker.actions.SELECT_RATE, {
            product_name: product.planDescription
          });
        }, 1000);
      }

      prevProduct.current = product;
    } else if (prevProduct.current) {
      scrollTimer.current = setTimeout(() => {
        if (content.current?.children?.length) {
          Array.from(content.current.children).forEach(el => {
            el.scrollTop = 0;
          });
        }

        content.current?.scrollTo(0, 0);
        modal.current.resetScroll();
      }, 300);
    }

    return () => clearTimeout(scrollTimer.current);
  }, [product, modal]);

  const currentProduct = product ?? visibleProduct;

  return (
    <Modal
      ref={modal}
      isOpen={!!product}
      id={id}
      className={classNames(styles.wrapper, {
        [styles.closed]: !product,
        adjustable: product?.isAdjustable
      })}
      contentIsScrollable={false}
      close={close}
    >
      <div ref={content} className={styles.content}>
        <RateModalForm
          modalRef={modal}
          product={currentProduct}
          loanDetails={loanDetails}
          className={styles.formWrapper}
        />
        <SampleLoan product={currentProduct} loanDetails={loanDetails} />
      </div>
    </Modal>
  );
});
